module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-header-3-fe1e278c7acd27fb4aede369af71900f.jpg";